/**
 * User: WangMeng
 * Date: 2018-07-17
 * Time: 17:45
 * Desc: 审计单位变更频繁
 */

import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class AuditUnits extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '近三年审计单位信息';
    }

    getColumns = () => {
        return [{
            title: '会计期间',
            dataIndex: 'reportYear',
            width: 200
        }, {
            title: '审计单位',
            dataIndex: 'Auditcompdom'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/AuditUnits.jsx